import { NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import {
    LISTING_STATE_PENDING_APPROVAL,
    LISTING_STATE_CLOSED,
    LISTING_STATE_DRAFT,
    propTypes,
} from '../../util/types';
import EditIcon from './EditIcon';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { bool, oneOfType, object, string } from 'prop-types';
import React from 'react';

export const ActionBarMaybe = (props) => {
    const { rootClassName, className, isOwnListing, listing, editParams } =
        props;
    const classes = classNames(rootClassName || css.actionBar, className);

    const state = listing.attributes.state;
    const isPendingApproval = state === LISTING_STATE_PENDING_APPROVAL;
    const isClosed = state === LISTING_STATE_CLOSED;
    const isDraft = state === LISTING_STATE_DRAFT;

    if (isOwnListing) {
        let ownListingTextTranslationId = 'ListingPage.ownListing';

        if (isPendingApproval) {
            ownListingTextTranslationId =
                'ListingPage.ownListingPendingApproval';
        } else if (isClosed) {
            ownListingTextTranslationId = 'ListingPage.ownClosedListing';
        } else if (isDraft) {
            ownListingTextTranslationId = 'ListingPage.ownListingDraft';
        }

        const message = isDraft
            ? 'ListingPage.finishListing'
            : 'ListingPage.editListing';

        const ownListingTextClasses = classNames(css.ownListingText, {
            [css.ownListingTextPendingApproval]: isPendingApproval,
        });

        return (
            <div className={classes}>
                <p className={ownListingTextClasses}>
                    <FormattedMessage id={ownListingTextTranslationId} />
                </p>
                <NamedLink
                    className={css.editListingLink}
                    name="EditListingPage"
                    params={editParams}>
                    <EditIcon className={css.editIcon} />
                    <FormattedMessage id={message} />
                </NamedLink>
            </div>
        );
    } else if (isClosed) {
        return (
            <div className={classes}>
                <p className={css.closedListingText}>
                    <FormattedMessage id="ListingPage.closedListing" />
                </p>
            </div>
        );
    }
    return null;
};
ActionBarMaybe.defaultProps = {
    rootClassName: null,
    className: null,
};

ActionBarMaybe.propTypes = {
    rootClassName: string,
    className: string,
    isOwnListing: bool.isRequired,
    listing: oneOfType([propTypes.listing, propTypes.ownListing]).isRequired,
    editParams: object.isRequired,
};

ActionBarMaybe.displayName = 'ActionBarMaybe';

export default ActionBarMaybe;
